import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { StateType } from "../../../../utils/types";
import {
  selectOnboardings,
  selectOnboardingsLoaded,
  selectOnboardingsLoading,
} from "../../../../redux/educator/selector";
import { getOnboarding } from "../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  onboardings: selectOnboardings(state),
  loading: selectOnboardingsLoading(state),
  loaded: selectOnboardingsLoaded(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ getOnboarding }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
